import React, { Component } from 'react'
import { Row, Col, Select, Spin, Input, Button, Table } from 'antd'
import { app } from "../../app"
import api from "../../api"
import utils from "../../utils"
import Head from "../../components/Head"
import Iconz from "../../components/Iconz"
import config from "../../config"
import '../../css/expert.css'

const Option = Select.Option
const Search = Input.Search

class EList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            total: 0,
            page: 1,
            posi_loading: true,
            data_loading: true,
            ppe_loading: true,
            dataList: [],
            ppeList: [],
            positionalList: [],
            positional_id: '0',
            ppe_class_id: '0',
            search_key: '',
        }
    }

    componentDidMount() {
        this._isMounted = true
        this.positionalSource()
        this.ppeSource()
        this.dataSource(1)
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 列表数据
     * @param page
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        const { positional_id, ppe_class_id, search_key } = this.state, params = {
            page,
            positional_id,
            ppe_class_id,
            search: search_key,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.ELists, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = []
        }
        if (page === this.state.page) {
            this.setData({ data_loading: false, dataList: utils.addArrayKey(data), total: parseInt(total || 0) })
        }
    }

    /**
     * 职称数据
     */
    positionalSource = async () => {
        let { flag, data, msg } = await app.post(api.EPositionalSelectLists)
        const state = { posi_loading: false }
        if (flag === 1) {
            state.positionalList = data
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    /**
     * 技能数据
     */
    ppeSource = async () => {
        let { flag, data, msg } = await app.post(api.PpeClass, { parent: 1 })
        const state = { ppe_loading: false }
        if (flag === 1) {
            state.ppeList = data
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    /**
     * 跳转详情
     * @param id
     */
    handleToDetail = (id) => {
        this.props.history.push('/expert-detail/' + id)
    }

    render() {
        let { posi_loading, ppe_loading, positionalList, ppeList, data_loading, page, total, dataList } = this.state,
            columns = [
                {
                    title: '头像',
                    dataIndex: 'head_img',
                    key: 'head_img',
                    width: '15%',
                    render: (img) => {
                        return (
                            <div style={{ width: 140, height: 104 }}>
                                <img style={{
                                    maxWidth: '100%',
                                    width: 'auto',
                                    height: 'auto',
                                    maxHeight: '100%'
                                }} src={config.imgUrl + img} alt="头像" />
                            </div>
                        )
                    }

                },
                {
                    title: '姓名',
                    dataIndex: 'name',
                    key: 'name',
                    width: '15%',
                },
                {
                    title: '性别',
                    dataIndex: 'sex',
                    key: 'sex',
                    width: '10%',
                },
                {
                    title: '是否内部',
                    dataIndex: 'is_volunteer',
                    key: 'is_volunteer',
                    width: '10%',
                },
                {
                    title: '职称类别',
                    dataIndex: 'positional',
                    key: 'positional',
                    width: '10%'
                },
                {
                    title: '专职课程',
                    dataIndex: 'ppe_class',
                    key: 'ppe_class',
                    width: '15%',
                    render: (ppe) => ppe.join('、')
                },
                {
                    title: '聘用期限',
                    dataIndex: 'employ_time',
                    key: 'employ_time',
                    width: '15%',
                },
                {
                    title: '查看',
                    dataIndex: 'id',
                    key: 'id',
                    width: '10%',
                    render: (id) => {
                        return (
                            <div>
                                <Button type="primary" onClick={() => this.handleToDetail(id)} size="small">详情</Button>
                            </div>
                        )
                    }
                },
            ]
        return (
            <div className="expert-page">
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48} />
                    </div>
                )} background="#3F89C1" height={78} history={this.props.history} />
                <div className="ep-content">
                    <div className="epc-title" style={{ paddingTop: '40px', marginBottom: '40px' }}>教练专家库</div>
                    <div className="epc-content">
                        <Row type="flex" justify="space-between" className="epc-filter">
                            <Col>
                                <Select defaultValue="0" style={{ width: '10rem', fontSize: '.8rem' }}
                                    onChange={async (value) => {
                                        await this.setData({ positional_id: value })
                                        await this.dataSource(1)
                                    }}
                                    notFoundContent={posi_loading ? <Spin size="small" /> : null}
                                >
                                    <Option value="0">全部</Option>
                                    {
                                        positionalList.map(p => (
                                            <Option key={p.value} value={p.value}>{p.title}</Option>
                                        ))
                                    }
                                </Select>
                                <Select defaultValue="0"
                                    style={{ width: '10rem', fontSize: '.8rem', marginLeft: '1rem' }}
                                    onChange={async (value) => {
                                        await this.setData({ ppe_class_id: value })
                                        await this.dataSource(1)
                                    }}
                                    notFoundContent={ppe_loading ? <Spin size="small" /> : null}
                                >
                                    <Option value="0">全部</Option>
                                    {
                                        ppeList.map(p => (
                                            <Option key={p.id} value={p.id}>{p.names}</Option>
                                        ))
                                    }
                                </Select>
                            </Col>
                            <Col>
                                <Search placeholder="搜索教练专家" style={{ width: '16rem', fontSize: '.8rem' }} onSearch={async (value) => {
                                    await this.setData({ search_key: value })
                                    await this.dataSource(1)
                                }} />
                            </Col>
                        </Row>
                        <Table columns={columns}
                            locale={app.tbLocale(data_loading)}
                            dataSource={dataList}
                            loading={data_loading}
                            scroll={{ y: 'calc(100vh - calc(9rem + 181px))' }}
                            pagination={{
                                total,
                                current: page,
                                pageSize: 20,
                                showTotal: (t) => `总记录${t}条`
                            }}
                            className="table-odd-even-row"
                            size="small"
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default EList



// WEBPACK FOOTER //
// ./src/routes/expert/EList.jsx